const formatDate = () => {
  const date = new Date();
  return new Intl.DateTimeFormat('pt-BR', {
    day: '2-digit',
    month: 'long',
    year: 'numeric',
  }).format(date);
};

const formatDateForPrint = `São Paulo, ${formatDate()}`;

export { formatDateForPrint };
